var SCAAFFCustomerReferSetting = {
    "program": {
        "active": false,
        "shop": "foodpunktest.myshopify.com",
        "incentive": {
            "type": "percentage",
            "value": "10.00",
            "price_rule_id": 1357477773576,
            "coupon": "UPPROMOTE_CUSTOMER_REFERRAL"
        },
        "program": "ODM1NzU="
    },
    "design": {
        "refer_customer_button": {
            "refer_button_text": "Empfehle uns Freunden und verdiene",
            "refer_background_color": "#1d85e8",
            "refer_text_color": "#ffffff",
            "web_position": "right-bottom",
            "mobile_position": "right-bottom"
        },
        "refer_customer_invite": {
            "popup_header": "Lade Freunde ein & erhalte 10% Provision von ihrem Einkauf",
            "popup_description": "Schicke deinen Freunden einen 10% Gutschein f\u00fcr ihren Einkauf. Sobald sie einen Einkauf t\u00e4tigen, erh\u00e4ltst du auch 10% Provision f\u00fcr jeden Kauf! Dein Guthaben kannst du dann im Shop bei uns einsetzen.",
            "button_text_get_invite": "Einladungslink erhalten",
            "button_copy_invite": "Einladungslink kopieren",
            "popup_background_color": "#1d85e8",
            "popup_text_color": "#ffffff"
        },
        "refer_customer_incentive_popup": {
            "shop_header": "Du bekommst 10% Rabatt",
            "shop_description": "Hurraa! Dein\/e Freund\/in hat dir einen 10% Gutschein geschenkt. Er wird am Checkout automatisch abgezogen.",
            "shop_button_text": "Jetzt shoppen",
            "shop_background_color": "#1d85e8",
            "shop_text_color": "#ffffff"
        }
    }
}